/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectFieldSettingsControllerReplaceForScopeMutationRequest, ProjectFieldSettingsControllerReplaceForScopeMutationResponse, ProjectFieldSettingsControllerReplaceForScopePathParams, ProjectFieldSettingsControllerReplaceForScope401, ProjectFieldSettingsControllerReplaceForScope403 } from "../../models/projectFieldSettingsController/ProjectFieldSettingsControllerReplaceForScope";

function getProjectFieldSettingsControllerReplaceForScopeUrl(scopeId: ProjectFieldSettingsControllerReplaceForScopePathParams["scopeId"]) {
  const res = { method: 'PUT', url: `/api/v1/scopes/${scopeId}/project-field-settings/bulk` as const }  
  return res
}

/**
 * @summary Replace the project field settings
 * {@link /api/v1/scopes/:scopeId/project-field-settings/bulk}
 */
export async function projectFieldSettingsControllerReplaceForScope(scopeId: ProjectFieldSettingsControllerReplaceForScopePathParams["scopeId"], data: ProjectFieldSettingsControllerReplaceForScopeMutationRequest, config: Partial<RequestConfig<ProjectFieldSettingsControllerReplaceForScopeMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ProjectFieldSettingsControllerReplaceForScopeMutationResponse, ResponseErrorConfig<ProjectFieldSettingsControllerReplaceForScope401 | ProjectFieldSettingsControllerReplaceForScope403>, ProjectFieldSettingsControllerReplaceForScopeMutationRequest>({ method : "PUT", url : getProjectFieldSettingsControllerReplaceForScopeUrl(scopeId).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}